<template>
  <div class="concern-page">
    <div class="row concern-page-header">
      <div class="row">
        <div
          class="tab-item" 
          :class="{'tab-item-active': item === selectedOptionTab}" 
          v-for="(item, index) in tabs" 
          :key="index"
          @click="onTabChange(item)"
          >
          {{item}}
        </div>
      </div>
      <div class="row">
        <el-button class="concern-management-btn" @click="manageConcerns">管理关注内容</el-button>
      </div>
    </div>
    <concern-companies v-if="companyCount && selectedOptionTab === '关注公司'" :companyCount="companyCount" :year="year" :month="month" :date="date" :day="day" :hour="hour" :minute="minute" :second="second" class="concern-companies"></concern-companies>
    <concern-companies-empty v-if="!companyCount && selectedOptionTab === '关注公司'"></concern-companies-empty>
    <concern-industry v-if="(themeCount ||industryCount) && selectedOptionTab === '关注产业'" :themeCount="themeCount" :industryCount="industryCount" :year="year" :month="month" :date="date" :day="day" :hour="hour" :minute="minute" :second="second" class="concern-companies"></concern-industry>
    <concern-industry-empty v-if="!themeCount && !industryCount && selectedOptionTab === '关注产业'"></concern-industry-empty>
    <concern-keywords v-if="selectedOptionTab === '关注关键词'" class="concern-companies"></concern-keywords>
    <concern-person v-if="selectedOptionTab === '关注人物'" :personCount="personCount" class="concern-companies"></concern-person>
  </div>
</template>

<script>
import ConcernCompanies from '@/components/concern/ConcernCompanies';
import ConcernKeywords from '@/components/concern/ConcernKeywords';
import ConcernCompaniesEmpty from '@/components/concern/ConcernCompaniesEmpty';
import ConcernIndustryEmpty from '@/components/concern/ConcernIndustryEmpty';
import ConcernIndustry from '@/components/concern/ConcernIndustry';
import ConcernPerson from '@/components/concern/ConcernPerson';
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';

export default {
  data() {
    return {
      keywordCount: -1,
      companyCount: -1,
      industryCount: -1,
      themeCount: -1,
      personCount: -1,
      username: '',
      tabs: ['关注公司', '关注产业', '关注关键词', '关注人物'],
      selectedOptionTab: '关注公司',
      timer: null,
      year: 2020,
      month: 0,
      date: 0,
      Date: new Date(),
      day: 0,
      hour: 0,
      minute: 0,
      second: 0,
      weekday: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
    };
  },
  methods: {
    getYearMonthDayDate() {
      this.year = new Date().getFullYear();
      this.month = new Date().getMonth() + 1;
      this.date = (new Date().getDate() < 10) ? `0${new Date().getDate()}` : new Date().getDate();
      this.day = this.weekday[new Date().getDay()];
    },
    onTabChange(item) {
      this.selectedOptionTab = item;
      if (this.selectedOptionTab === '关注产业') {
        this.$router.push({
          path: '/concern',
          query: {
            type: 'industry'
          }
        });
      } else if (this.selectedOptionTab === '关注关键词') {
        this.$router.push({
          path: '/concern',
          query: {
            type: 'keywords'
          }
        });
      } else if (this.selectedOptionTab === '关注人物') {
        this.$router.push({
          path: '/concern',
          query: {
            type: 'person'
          }
        });
      } else {
        this.$router.push({
          path: '/concern'
        });
      }
    },
    manageConcerns() {
      if (this.selectedOptionTab === '关注产业') {
        this.$router.push({
          path: '/follow',
          query: {
            type: 'industry'
          }
        });
      } else if (this.selectedOptionTab === '关注关键词') {
        this.$router.push({
          path: '/follow',
          query: {
            type: 'keywords'
          }
        });
      } else if (this.selectedOptionTab === '关注人物') {
        this.$router.push({
          path: '/follow',
          query: {
            type: 'person'
          }
        });
      } else {
        this.$router.push({
          path: '/follow'
        });
      }
    },
    getMonitorCount() {
      QuestionQuery.getMonitorCount(this.username).then(res => {
        this.industryCount = res.industry;
        this.companyCount = res.company;
        this.keywordCount = res.keyword;
        this.themeCount = res.theme;
        this.personCount = res.person;
      });
    }
  },
  watch: {
    hour(val) {
      if (!val) {
        this.getYearMonthDayDate();
      }
    }
  },
  components: {
    ConcernCompanies,
    ConcernCompaniesEmpty,
    ConcernIndustryEmpty,
    ConcernIndustry,
    ConcernPerson,
    ConcernKeywords
  },
  created() {
    this.$nextTick(() => document.querySelector('.concern-page-header').scrollIntoView({ block: 'center' }));
    // eslint-disable-next-line
    const _this = this;
    this.timer = window.setInterval(() => {
      _this.hour = new Date().getHours();
      _this.minute = (new Date().getMinutes() < 10) ? `0${new Date().getMinutes()}` : new Date().getMinutes();
      _this.second = (new Date().getSeconds() < 10) ? `0${new Date().getSeconds()}` : new Date().getSeconds();
    }, 1000);
  },
  mounted() {
    if (this.$route.query.type === 'industry') {
      this.selectedOptionTab = '关注产业';
    } else if (this.$route.query.type === 'keywords') {
      this.selectedOptionTab = '关注关键词';
    } else if (this.$route.query.type === 'person') {
      this.selectedOptionTab = '关注人物';
    }
    this.username = authService.getLoggedUserName();
    this.getYearMonthDayDate();
    this.getMonitorCount();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);        
    }
  }
};
</script>

<style lang="scss" scoped>
.concern-page {
  width: 1200px;
  margin: 0 auto;
  padding: 16px 0;
  min-height: calc(100vh - 59px);
  .concern-page-header {
    justify-content: space-between;
    padding: 0 24px;
    height: 44px;
    line-height: 44px;
    width: 100%;
    color: #747990;
    background-color: #ffffff;
    font-size: 14px;
    .tab-item {
      margin-right: 32px;
      cursor: pointer;
      &:hover {
        color: #45a8cc;
      }
    }
    .tab-item-active {
      color: #45a8cc;
    }
    .concern-count {
      margin-right: 10px;
      color: #747990;
      font-size: 12px;
      .count {
        color: #45a8cc;
      }
    }
    .concern-management-btn {
      margin-top: 9px;
      height: 26px;
      padding: 0 12px;
      border-radius: 2px;
      border: none;
      font-size: 14px;
      font-weight: 400;
      color: #464d6c;
      background-color: #f7f8fc;
      &:hover {
        color: #464d6c;
        background-color: #eaebef;
      }
      &:focus {
        color: #464d6c;
        background-color: #eaebef;
      }
      &:active {
        color: #464d6c;
        background-color: #eaebef;
      }
    }
  }
  .concern-companies {
    margin-top: 10px;
  }
}
</style>

